import validate from "/home/runner/work/hive-ui/hive-ui/node_modules/nuxt/dist/pages/runtime/validate.js";
import routing_45global from "/home/runner/work/hive-ui/hive-ui/middleware/routing.global.ts";
import manifest_45route_45rule from "/home/runner/work/hive-ui/hive-ui/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  routing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}